import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import FAQSection from '../components/home/FAQSection';
import CTASection from '../components/home/CTASection';

export default function FAQPage() {
  const { t } = useLanguage();

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <h1>{t.faq.title}</h1>
        </div>
      </div>
      <FAQSection />
      <CTASection />
    </>
  );
}
